import { render, staticRenderFns } from "./barEacher.vue?vue&type=template&id=075a4b25&"
import script from "./barEacher.vue?vue&type=script&lang=js&"
export * from "./barEacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports